// extracted by mini-css-extract-plugin
export var focus = "Toggle-module__focus";
export var label = "Toggle-module__label";
export var on = "Toggle-module__on";
export var status = "Toggle-module__status";